<template>
    <div  class="mx-10 ma-5">
        <v-card class="pa-5">
            <div>
                 <!-- Page Title -->
                <PageTitle :title="'Bank Transactions'" class="pb-5"></PageTitle>
                <Transactions></Transactions>

            </div>
        </v-card>

    </div>
</template>

<script>
import PageTitle from "@/components/shared/PageTitle";
import Transactions from "@/components/CompanyBanks/AccountTransactions";


export default ({

    name:'goodsReturnDetails',
    components:{PageTitle,Transactions},
   
    
})
</script>
